<Modal :value="visible" :title="title" :width="45" :closable="false" :mask-closable="false" :scrollable="true"
    :mask="true">
    <Spin :fix="true" v-show="loading"></Spin>
    <Tree ref="orgTree" :show-checkbox="multiple" @on-check-change="handleTreeCheckChange" :data="data"
        :multiple="multiple" :render="handleTreeRender"></Tree>
    <div slot="footer">
        <Button @click="handelCancelClick">取消</Button>
        <Button v-if="multiple" type="primary" @click="handleOkClick">确定</Button>
    </div>
</Modal>